import React, { Component } from 'react';
import { connect } from "react-redux";
// import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {togglePriceWorksheetOpened} from "../../actions/priceWorksheetActions";

class PriceWorksheetButton extends Component {

  static propTypes = {
    // questionShown: PropTypes.bool
  };

  handlePriceWorkSheetButtonClick = () => {
    this.props.togglePriceWorksheetOpened(!this.props.priceWorksheetOpened);
  };

  render() {
    // let fabSettings = this.props.fabricatorSettings;
    return (
      // <button className={"materials-button materials-button--install" + ((this.props.questionShown || this.props.questionNoClicked) && (fabSettings.addLaborCustomer || (document.kvConfig.isBackend && fabSettings.addLaborInstaller)) ? " materials-button--install--visible" : "")}
      //         onClick={() => this.props.toggleInstOpened(!this.props.instOpened)}>
      //   <span className="materials-button__text">Install?</span>
      // </button>
      <button className="ui-button2 ui-button2--blue" onClick={this.handlePriceWorkSheetButtonClick}>
        <FormattedMessage id={this.props.priceWorksheetOpened ? "shoppingCart.footer.discountsBackButton" : "shoppingCart.footer.discountsButton"}/>
      </button>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    priceWorksheetOpened: store.priceWorksheetState.priceWorksheetOpened,
    fabricatorSettings: store.fabricatorState.settings,
  };
};

export default connect(mapStateToProps, {
  togglePriceWorksheetOpened
})(PriceWorksheetButton);
